





























































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Emit } from "vue-property-decorator";
import AddFlightPriceModal from "../../../views/pages/flight/modals/addFlightPriceModal.vue";
import AddFlightRuleModal from "../../../views/pages/flight/modals/addFlightRuleModal.vue";
import AddFlightQuotaModal from "../../../views/pages/flight/modals/addFlightQuotaModal.vue";
import UpdateFlightPriceModal from "../../../views/pages/flight/modals/updateFlightPriceModal.vue";
import UpdateFlightInformationModal from "../../../views/pages/flight/modals/updateFlightInformationModal.vue";
import moment from "moment";
import FlightTreeList from "@/store/entities/flight/flightTreeList";
import FlightChangeInput from "@/store/entities/flight/flightChangeInput";
import Airport from "@/store/entities/flight/airport";
import FlightChangeGeneral from "@/store/entities/flight/flightChangeGeneral";
import FlightQuota from "@/store/entities/flight/flightQuota";
import AirlineCompany from "@/store/entities/flight/airlineCompany";
import FlightProvider from "@/store/entities/flight/flightProvider";
import Aircraft from "@/store/entities/flight/aircraft";
import Currency from "@/store/entities/currency";
import FlightPriceGeneral from "@/store/entities/flight/flightPriceGeneral";
import FlightChangeUpdate from "@/store/entities/flight/flightChangeUpdate";
import FlightInput from "@/store/entities/flight/flightInput";
var _ = require("lodash");
@Component({
  components: {
    AddFlightPriceModal,
    AddFlightRuleModal,
    AddFlightQuotaModal,
    UpdateFlightPriceModal,
    UpdateFlightInformationModal,
  },
  filters: {
    formatOnlyDate(value: string) {
      if (!value) return '';
      return moment(value).format('DD.MM.YYYY');
    }
  }
})
export default class FlightChange extends Vue {
  isOpened:boolean=true;
  isOpenModal: boolean = false;
  isOpenAddFlightRuleModal: boolean = false;
  isOpenAddFlightQuotaModal: boolean = false;
  isOpenUpdateFlightPriceModal: boolean = false;
  isOpenUpdateFlightInformationModal: boolean = false;
  menu: boolean = false;
  menu2: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  mockDataPriceList: any[] = [];
  headersPriceList: any[] = [];
  mockDataFlightRules: any[] = [];
  headersFlightRules: any[] = [];
  mockDataFlightQuota: any[] = [];
  headersFlightQuota: any[] = [];
  rows: any[]=[];
  newRow:any = {
      id: '',
      flightId: '',
      minumumDay: '',
      maxiumumDay: '',
      value: ''
    };
  departureDate: string = null;
  arrivalDate: string = null;
  breadcrumbsItems: any[] = [];
  checkbox: boolean = false;
  items: any[] = [];
  active_tab: number = 0;
  active_tab1: number = 0;
  selected: any[] = [];
  value: any;
  startDate: Date = null;
  startDateMenu: boolean = false;
  endDate: Date = null;
  endDateMenu: boolean = false;
  flightTreeList: FlightTreeList[] = [];
  flightChangeInput: FlightChangeInput = new FlightChangeInput();
  arrivals: string="";
  airports: Airport[] = [];
  flightChangeGeneral: FlightChangeGeneral[] = [];
  flightChangeGeneralTwice: FlightChangeGeneral = new FlightChangeGeneral();
  flightPriceGeneral: FlightPriceGeneral = new FlightPriceGeneral();
  flightPriceGeneralEdit: FlightPriceGeneral = new FlightPriceGeneral();
  flightQuota: FlightQuota[] = [];
  active: any[] = [];
  open: any[] = [];
  selection: any[] = [];
  airlineCompanies: AirlineCompany[] = [];
  flightProviders: FlightProvider[] = [];
  aircrafts: Aircraft[] = [];
  currencies: Currency[] = [];
  selectionType: string = "independent";
  editedIndex: number = -1;
  selectedPrices: any[] = [];
  flightChangeUpdate: FlightChangeUpdate = new FlightChangeUpdate();
  flightInputInfo: FlightInput[] = [];
  flightPriceInfo: FlightPriceGeneral[] = [];
  startDateAfterEndDate: string = "";
  get selectedItem() {
    return this.active;
  }

  updateAllRules(item) {
    if(    item.flightPriceRules.length>0){
         this.flightChangeGeneral.forEach(element => {
    element.flightPriceRules = item.flightPriceRules.map(rule => {
      const ruleCopy = { ...rule };
      ruleCopy.id = "";
      ruleCopy.flightId = element.id;
      return ruleCopy;
    });
  
  });
    }
    else{
Vue.$toast.open({
            message: "Uygulanacak Kural Bulunamadı",
            type: "error",
            duration: 2000,
          });
    }
       
 

  }
   isValidRow(newRow) {
        return newRow.minumumDay !== '' && newRow.maximumDay !== '' && newRow.value !== '';
    }
  addRow(item) {
    if(this.isValidRow(this.newRow)){
    this.newRow.flightId = item.id;
    item.flightPriceRules.push({ ...this.newRow });
    this.newRow = { MinDay: '', MaxDay: '', Price: '' };
    }
    else{
       Vue.$toast.open({
            message: "Alanların tümünü doldurmalısınız.",
            type: "error",
            duration: 2000,
          });
    }
   

  }
  deleteRow(item,index) {
    // Belirtilen indeksteki satırı sil
    item.flightPriceRules.splice(index, 1);
  }

  updateFlightInfo(value) {
    this.flightInputInfo = [];
    this.flightInputInfo.push(value);
    let firstArray = this.flightInputInfo;
    let changedArray = this.flightChangeGeneral;
    changedArray = changedArray.map((el, key) => {
      var found = firstArray.find((s) => s[key] === el[key]);
      if (found.arrivalHour < el.departureHour) {
        el.arrivalDate = moment(el.arrivalDate)
          .add(1, "days")
          .format();
      }
      if (found) {
 
        el.isActive=value.isActive;
        el.flightIsActive=value.isActive;
        el = Object.assign(el, found);
        
 
      }
      return el;
    });
  }

  updateFlightPrices(value) {
    let array = [];
    array.push(value);
    this.flightChangeGeneral.map((item) => {
      item.flightPrices[0].flightPriceGenerals.map((flight, key) => {
        let matched = array.find((t) =>
          t["pricePassengerType"].find((x) => x === flight.pricePassengerTypeId)
        );
        var found = array.find((s) => s[key] === flight[key]);
        if (found) {
          flight = Object.assign(flight, matched);
        }
        return flight;
      });
    });
  }
  async updateFlights(e) {
    // Önce tarih değişikliği olan uçuşları kontrol et
    let flightsWithDateChange = this.flightChangeGeneral.filter(item => {
      return (
        moment(item.departureDate).format('YYYY-MM-DD') !== moment(item.originalDepartureDate).format('YYYY-MM-DD') ||
        moment(item.arrivalDate).format('YYYY-MM-DD') !== moment(item.originalArrivalDate).format('YYYY-MM-DD')
      );
    });

    console.log("Tarih değişikliği olan uçuşlar:", flightsWithDateChange);

    if (flightsWithDateChange.length > 0) {
        try {
            const response = await this.$store.dispatch({
                type: "flight/checkFlightSales",
                data: flightsWithDateChange
            });

            // Eğer satış varsa kullanıcıya detaylı bilgi göster
            if (response.data.result && response.data.result.length > 0) {
                // Satış olan uçuşların detaylarını hazırla
                const flightsWithSales = response.data.result.map(flight => {
                  return {
                    ucusNo: flight.flightNo,
                    kalkisVaris: (flight.fromAirport.id || '-') + '-' + (flight.toAirport.id || '-'),
                    kalkisTarihi: moment(flight.departureDate).format('DD.MM.YYYY')

                  };
                });

                // HTML içeriğini oluştur
                const htmlContent = `
                  <div class="sales-warning" style="text-align:center;">
                    <div style="font-size:48px;color:#FFA726;margin-bottom:8px;">
                      <i class="el-icon-warning-outline"></i>
                    </div>
                 
                    <div class="sales-table-flex" style="display:flex;flex-direction:column;gap:8px;align-items:center;">
                      <div class="sales-table-header" style="display:flex;gap:12px;font-weight:bold;border-bottom:1px solid #eee;padding-bottom:4px;">
                        <div style="min-width:80px;">Uçuş No</div>
                        <div style="min-width:140px;">Kalkış-Varış</div>
                        <div style="min-width:110px;">Kalkış Tarihi</div>
                      </div>
                      ${flightsWithSales.map(flight => `
                        <div class="sales-table-row" style="display:flex;gap:12px;padding:4px 0;border-bottom:1px solid #f5f5f5;">
                          <div style="min-width:80px;">${flight.ucusNo}</div>
                          <div style="min-width:140px;">${flight.kalkisVaris}</div>
                          <div style="min-width:110px;">${flight.kalkisTarihi}</div>
                        </div>
                      `).join('')}
                    </div>
                    <p class="warning-text" style="margin-top:16px;">Bu uçuşlarda tarih değişikliği yapmak istediğinizden emin misiniz?</p>
                  </div>
                `;

                // Onay dialogunu göster
                const result = await this.$swal({
                    title: 'Uçuş Satış Uyarısı',
                    html: htmlContent,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Evet, Değiştir',
                    cancelButtonText: 'Hayır, İptal Et',
                    customClass: {
                        container: 'sales-warning-dialog'
                    }
                });

                if (!result.isConfirmed) {
                    Vue.$toast.open({
                        message: "İşlem iptal edildi.",
                        type: "info",
                        duration: 2000
                    });
                    return;
                }
            }
        } catch (error) {
            Vue.$toast.open({
                message: "Satış kontrolü sırasında bir hata oluştu.",
                type: "error",
                duration: 2000
            });
            return;
        }
    }

    // Mevcut updateFlights işlemine devam et
    let changedItems = [];
    
    for (let item of this.flightChangeGeneral) {
        var flightChangeUpdate: FlightChangeUpdate = new FlightChangeUpdate();
        flightChangeUpdate.airlineCompany = item.airlineCompany;
        flightChangeUpdate.airplane = item.airCraft;
        flightChangeUpdate.arrivalDate = item.arrivalDate;
        flightChangeUpdate.arrivalHour = item.arrivalHour;
        flightChangeUpdate.departureDate = item.departureDate;
        flightChangeUpdate.departureHour = item.departureHour;
        flightChangeUpdate.baggageLimit = item.baggageLimit;
        flightChangeUpdate.code = item.code;
        flightChangeUpdate.currency = item.currency;
        flightChangeUpdate.flightNo = item.flightNo;
        flightChangeUpdate.flightPriceRules = item.flightPriceRules;
        flightChangeUpdate.flightQuotas = this.flightQuota;
        flightChangeUpdate.fromAirport = item.fromAirport;
        flightChangeUpdate.id = item.id;
        flightChangeUpdate.isActive = item.flightIsActive;
        flightChangeUpdate.isPropertyAnyChange = true;
        flightChangeUpdate.open = true;
        flightChangeUpdate.packageProvider = item.packageProvider;
        flightChangeUpdate.toAirport = item.toAirport;
        flightChangeUpdate.totalQuota = item.totalQuota;
        flightChangeUpdate.IsCampaign = item.isCampaign;
        flightChangeUpdate.handBaggageLimit = item.handBaggageLimit;
        let items = [];
        for (let price of item.flightPrices[0].flightPriceGenerals) {
            items.push({
                flightId: item.flightPrices[0].flightId,
                id: price.id,
                flightClass: item.flightPrices[0].flightClass,
                flightSegment: item.flightPrices[0].flightSegment,
                isGroup: item.flightPrices[0].isGroup,
                isNew: false,
                isPropertyAnyChange: false,
                maxAge: price.maxAge,
                minAge: price.minAge,
                oneWayPrice: price.endUserOwPrice,
                roundTripPrice: price.endUserRtPrice,
                passengerType: price.passengerType,
                salesChannel: price.salesChannel,
            });
        }
        let quotas = [];
        for (let quota of item.flightPrices[0].flightQuotas) {
            quotas.push({
                flightClass: quota.flightClass,
                flightId: item.flightPrices[0].flightId,
                id: quota.id,
                isGroup: quota.isGroup,
                isNew: false,
                isPropertyAnyChange: false,
                quota: quota.quota,
                remainingQuota: quota.remainingQuota,
            });
        }
        let rules = [];
        for (let row of item.flightPriceRules) {
            let rule = {
                ...(row.id !== "" && { id: row.id }),
                flightId: row.flightId,
                minumumDay: row.minumumDay,
                maximumDay: row.maximumDay,
                value: row.value,
            };
            rules.push(rule);
        }
        flightChangeUpdate.flightPriceRules = rules;
        flightChangeUpdate.flightPriceGenerals = items;
        flightChangeUpdate.flightQuotas = quotas;
        changedItems.push(flightChangeUpdate);
    }

    this.$store
        .dispatch({
            type: "flight/updateFlights",
            data: changedItems,
        })
        .then((res) => {
            if (res.status === 200) {
                Vue.$toast.open({
                    message: "Tebrikler başarıyla kaydedildi.",
                    type: "success",
                });
            } else {
                Vue.$toast.open({
                    message: "Bir hata oluştu daha sonra tekrar deneyiniz.",
                    type: "error",
                    duration: 2000,
                });
            }
        });
}

  close() {
    setTimeout(() => {
      this.flightPriceGeneral = Object.assign({}, this.flightPriceGeneralEdit);
      this.editedIndex = -1;
    }, 300);
  }
  async addSelectionItem(item: any) {
    if (item.children == undefined) {
      await this.getFlights(item);
    }
  }

  parseDate(date: string[]) {
    if (!date) return null;
    let items = [];
    for (let item of date) {
      var x = moment(item).format("DD-MM-yyyy");
      items.push(x);
    }
    return items;
  }

  get setDate() {
    return this.parseDate(
      this.flightChangeGeneral.map((item) => item.departureDate)
    );
  }
  get setDate2() {
    return this.parseDate(
      this.flightChangeGeneral.map((item) => item.arrivalDate)
    );
  }

  async getFlights(input) {
    var itemIndex = this.flightChangeGeneral.findIndex((x) => x.id == input);
    if (itemIndex != -1) {
        this.flightChangeGeneral.splice(itemIndex, 1);
    } else {
        await this.$store
            .dispatch({
                type: "flight/getFlights",
                data: input,
            })
            .then((res) => {
                const flight = res.data.result.items[0];
                // Orijinal tarihleri sakla
                flight.originalDepartureDate = moment(flight.departureDate).format('YYYY-MM-DD');
                flight.originalArrivalDate = moment(flight.arrivalDate).format('YYYY-MM-DD');
                console.log("Orijinal tarihler:", {
                    departure: flight.originalDepartureDate,
                    arrival: flight.originalArrivalDate
                });
                this.flightChangeGeneral.push(flight);
            });
    }
    this.orderSelect();
  }

   get customDateFormat() {
    
    return 'D (50 TRY)';
    };
  filterData(item, queryText) {
  
  return (
    item.id.toLowerCase().includes(queryText.toLowerCase()) ||  
    item.name.toLowerCase().includes(queryText.toLowerCase())
  );
}


 orderSelect(){
  if(this.flightChangeGeneral.length>1){
    this.flightChangeGeneral.sort(this.compareDates);
  }
 
 }

  compareDates(a, b) {
  return moment(a.departureDate, "YYYY-MM-DD").diff(moment(b.departureDate, "YYYY-MM-DD"));
  }
  @Watch("selection")
  onPropertChangedSelection(newValue, old) {
  
    const firstLength = newValue.length;
    const lastLength = old.length;
    if (lastLength === 0 && firstLength > 1) {
      for (let item of newValue) {
        this.addSelectionItem(item.id);
      }
    } else if (firstLength > lastLength) {
      this.addSelectionItem(newValue[firstLength - 1].id);
    } else if (firstLength > 0 && firstLength < lastLength) {
      let difference = old.filter((x) => !newValue.includes(x));
      const index = old.indexOf(difference[0]);
      this.flightChangeGeneral.splice(index, 1);
    } else {
      this.flightChangeGeneral.length = 0;
    }
  }

  async getAirlineCompanies() {
    await this.$store.dispatch({
      type: "airlineCompany/getAirlineCompanies",
    });

    this.airlineCompanies = this.$store.state.airlineCompany.list;
  }

  async getFlightProviders() {
    await this.$store.dispatch({
      type: "flightProvider/getFlightProviders",
    });

    this.flightProviders = this.$store.state.flightProvider.list;
  }

  async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  }

  get getDepartureDate() {
    return;
    //  moment(this.flightChangeGeneral.departureDate).format('DD-MM-yyyy');
  }
  get getDepartureDate2() {
    return moment(this.flightChangeGeneralTwice.departureDate).format(
      "DD-MM-yyyy"
    );
  }

  get getEndDate() {
    return this.endDate
      ? (this.flightChangeInput.flightDateEnds = moment(this.endDate).format(
          "DD-MM-yyyy"
        ))
      : "";
  }

  get getStartDate() {
    return this.startDate
      ? (this.flightChangeInput.flightDateStarts = moment(
          this.startDate
        ).format("DD-MM-yyyy"))
      : "";
  }
  get getEndDate1() {
    return;
    // moment(this.flightChangeGeneral.arrivalDate).format('DD-MM-yyyy');
  }

  get getStartDate1() {
    return;
    // (this.departureDate = moment(
    //   this.flightChangeGeneral.departureDate
    // ).format('DD-MM-yyyy'));
  }

  get getEndDate2() {
    return moment(this.flightChangeGeneralTwice.arrivalDate).format(
      "DD-MM-yyyy"
    );
  }

  get getStartDate2() {
    return (this.departureDate = moment(
      this.flightChangeGeneralTwice.departureDate
    ).format("DD-MM-yyyy"));
  }
  async searchFlights() {
    this.getSerialization();
    const data = this.flightChangeInput;
    data.flightDateEnds = moment(this.endDate).format("MM-DD-yyyy");
    data.flightDateStarts = moment(this.startDate).format("MM-DD-yyyy");
    data.arrivalAirports = this.flightChangeInput.arrivalAirports;
    data.flightNo = this.flightChangeInput.flightNo;
 
    data.isActive = this.flightChangeInput.isActive;
    if (!moment(this.startDate).isValid()) {
      data.flightDateStarts = moment()
        .add(-3, "months")
        .format("MM-DD-yyyy");
    }
    if (!moment(this.endDate).isValid()) {
      data.flightDateEnds = moment()
        .add(8, "months")
        .format("MM-DD-yyyy");
    }

    await this.$store
      .dispatch({
        type: "flight/getFlightTreeList",
        data: this.flightChangeInput,
      })
      .then((res) => {
        let newArray = [];
        const data = res.data.result;

        for (let i = 0; i < data.length; i++) {
          newArray.push({
            id: i,
            name: data[i].name,
            children: [],
            isBusiness: data[i].isBusiness
          });

          let childs = newArray[i].children;

          for (let j = 0; j < data[i].children.length; j++) {
            childs.push({
              id: data[i].children[j].dataAttributes.id,
              name: data[i].children[j].name,
              isBusiness: data[i].children[j].isBusiness
            });
          }
        }
        this.flightTreeList = newArray;

        this.flightTreeList.sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      })
      .catch((err) => console.log(err));
  }

  async created() {
    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Uçuş", disabled: true },
      { text: "Uçuş Değişimi", disabled: true },
    ];

    this.flightChangeInput.isActive = false;

    (this.headers = [
      { text: "Kalkış - Varış", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNo" },
      { text: "Havayolu Firması", value: "company" },
      { text: "Kalkış Tarihi", value: "departure" },
      { text: "Uçuş Süresi", value: "flightHour" },
      { text: "Toplam Kota", value: "totalQuota" },
      { text: "Para Birimi", value: "currency" },
      { text: "", value: "" },
      { text: "", value: "" },
    ]),

      await this.$store.dispatch({
        type: "airport/getAirports",
        data: "{}",
      });

    this.airports = this.$store.state.airport.list;

    this.getAirlineCompanies();
    this.getFlightProviders();
    // this.getAircrafts();
    this.getCurrencies();
  }

  get getMinEndDate() {
    return this.startDate
      ? moment(this.startDate)
          .add(2, "days")
          .toISOString()
          .slice(0, 10)
      : "";
  }

  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
  }

  openAddFlightRuleModal() {
    this.isOpenAddFlightRuleModal = true;
  }
  closeAddFlightRuleModal() {
    this.isOpenAddFlightRuleModal = false;
  }

  openAddFlightQuotaModal() {
    this.isOpenAddFlightQuotaModal = true;
  }
  closeAddFlightQuotaModal() {
    this.isOpenAddFlightQuotaModal = false;
  }

  openUpdateFlightPriceModal() {
    this.isOpenUpdateFlightPriceModal = true;
  }
  closeUpdateFlightPriceModal() {
    this.isOpenUpdateFlightPriceModal = false;
  }

  openUpdateFlightInformationModal() {
    this.isOpenUpdateFlightInformationModal = true;
  }
  closeUpdateFlightInformationModal() {
    this.isOpenUpdateFlightInformationModal = false;
  }

  getSerialization() {
    if (this.arrivals.length == 7) {
      const departure = this.arrivals.substring(0, 3);
      const arrival = this.arrivals.substring(4, 7);
      this.flightChangeInput.arrivalAirports=arrival;
      this.flightChangeInput.departureAirports=departure;
    }
  }

  openDetail() {
    this.isOpened = true;
  }
  
  closeDetail() {
    this.isOpened = false;
  }
}
